// Runtime configuration - loaded from /config.js at startup
// This allows environment variables to be set at container runtime, not build time

interface RuntimeConfig {
  API_URL: string;
}

// Default config (fallback values)
const defaultConfig: RuntimeConfig = {
  API_URL: '/api',
};

// Runtime config is injected into window.__RUNTIME_CONFIG__ by config.js
declare global {
  interface Window {
    __RUNTIME_CONFIG__?: Partial<RuntimeConfig>;
  }
}

export function getConfig(): RuntimeConfig {
  const runtimeConfig = window.__RUNTIME_CONFIG__ || {};

  return {
    API_URL: runtimeConfig.API_URL || defaultConfig.API_URL,
  };
}

// Convenience getter for API URL
export function getApiUrl(): string {
  return getConfig().API_URL;
}
